import { useEffect, useState, useRef } from 'react';
var useInView = function (options) {
    var observer;
    var ref = useRef(null);
    var _a = useState(false), inView = _a[0], setInView = _a[1];
    var _b = options.delay, delay = _b === void 0 ? 0 : _b, _c = options.threshold, threshold = _c === void 0 ? 0 : _c, rootMargin = options.rootMargin, triggerOnce = options.triggerOnce;
    useEffect(function () {
        if (window.IntersectionObserver === undefined) {
            console.error([
                'IntersectionObserver is not available',
                'Please make sure you are running on client side',
                'or inside of a useEffect()',
            ].join('\n'));
            return function () {
                // Nothing to cleanup
            };
        }
        observer = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            setTimeout(function () {
                setInView(entry.isIntersecting);
            }, delay);
            if (triggerOnce && entry.isIntersecting && ref.current) {
                observer.unobserve(ref.current);
            }
        }, { rootMargin: rootMargin, threshold: threshold });
        var currentRef = ref.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return function () {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
            observer.disconnect();
        };
    }, [ref]);
    return { inView: inView, ref: ref };
};
export default useInView;
//# sourceMappingURL=useInView.js.map